import Vue from 'vue'
import Vuex from 'vuex'
import { session } from '../utils/storage'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    accessToken: session.get("access_token"),
    router: "",
    currentBook: session.get("current_book"),
  },
  mutations: {
    receiveAccessToken(state, accessToken) {
      state.accessToken = accessToken;
      if(accessToken === null) {
        session.del("access_token");
      } else {
        session.set("access_token", accessToken);
      }
    },
    recevieRouter(state, router) {
      state.router = router
    },
    recevieCurrentBook(state, book) {
      state.currentBook = book;
      if (book === null) {
        session.del("current_book");
      } else {
        session.set("current_book", book);
      }
    }
  },
  actions: {
  },
  modules: {
  }
})
